module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ismegink.lt","short_name":"Ismegink.lt","start_url":"/","background_color":"#292566","theme_color":"#292566","display":"minimal-ui","icon":"src/images/ismegink-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2d474dcce8426183f415e0d154f3065a"},
    }]
